import React, { FC, SVGProps } from 'react';
import { ReactComponent as LibraryIcon } from '../../assets/images/icon/ico_library.svg';
import { ReactComponent as ShareIcon } from '../../assets/images/icon/ico_share.svg';
import { ReactComponent as MydriveIcon } from '../../assets/images/icon/ico_mydrive.svg';
import { ReactComponent as SearchIcon } from '../../assets/images/icon/ico_search.svg';
import { ReactComponent as Trash } from '../../assets/images/icon/ico_trash.svg';
import { ReactComponent as Classroom } from '../../assets/images/icon/ico_class.svg';
import { ReactComponent as SettingsIcon } from '../../assets/images/icon/ico_setting.svg';
import { ReactComponent as UserGuideIcon } from '../../assets/images/icon/ico_userguide_default.svg';
import { ReactComponent as GridIcon } from '../../assets/images/icon/ico_layout_card.svg';
import { ReactComponent as ListIcon } from '../../assets/images/icon/ico_layout_list.svg';
import { ReactComponent as EditIcon } from '../../assets/images/icon/panel_editor.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/icon/ico_book_info.svg';
import { ReactComponent as BookSelectIcon } from '../../assets/images/icon/ico_book_select.svg';
import { ReactComponent as CheckIcon } from '../../assets/images/icon/ico_check.svg';

interface Icons {
  [name: string]: FC<SVGProps<SVGSVGElement>>;
}

interface IconProps {
  name: string;
  classname?: string;
  isDisabled?: boolean;
}

const icons: Icons = {
  library: LibraryIcon,
  share: ShareIcon,
  mydrive: MydriveIcon,
  search: SearchIcon,
  trash: Trash,
  classroom: Classroom,
  settings: SettingsIcon,
  userGuide: UserGuideIcon,
  grid: GridIcon,
  list: ListIcon,
  edit: EditIcon,
  info: InfoIcon,
  bookSelect: BookSelectIcon,
  check: CheckIcon,
};

export default function Icon({ name, classname, isDisabled }: IconProps) {
  return React.createElement(icons[name], {
    className: classname,
    style: isDisabled ? { opacity: 0.5 } : {},
  });
}
